import { DisplayBy } from '../../../constants/DisplayBy';
import React from 'react';

interface SplitRadioButtonProps {
  value: DisplayBy;
  checked: boolean;
  onChange: () => void;
  label: string;
  name: string;
}

const SplitRadioButton = ({ value, checked, onChange, label, name }: Readonly<SplitRadioButtonProps>) => (
  <label className="radioLabel">
    <input
      className="radioInput"
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      aria-label={label}
    />
    <span className="customRadio" />
    <span className="radioText">{label}</span>
  </label>
);

export default SplitRadioButton;
